/* "Escribir una reseña" dentro de la ficha. Abre el formulario en una ventana
   (<dialog>) sobre la misma página en vez de ir a /pages/resena.
   Captura cualquier enlace a /pages/resena?producto=… o con data-lenz-write
   (botón de la sección de reseñas y la calificación bajo el título). Sin JS, el
   enlace sigue llevando a la página. El formulario (lenz-review-form.js/.css) se
   carga recién al primer clic. Datos en #lenz-review-write
   (sections/lenz-reviews.liquid). */
(function () {
  'use strict';
  var cfg = document.getElementById('lenz-review-write');
  if (!cfg || !window.HTMLDialogElement) return;
  var d = cfg.dataset;
  var loading = null, dialog = null, opener = null;

  function load() {
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var pending = 2;
      function done() { if (--pending === 0) resolve(); }
      var css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = d.formCss; css.onload = done; css.onerror = reject;
      document.head.appendChild(css);
      if (window.LenzReviewForm) done();
      else {
        var js = document.createElement('script');
        js.src = d.formJs; js.onload = done; js.onerror = reject;
        document.head.appendChild(js);
      }
    });
    loading.catch(function () { loading = null; });
    return loading;
  }

  function close() { if (dialog && dialog.open) dialog.close(); }

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'lenz-rmodal';
    dialog.setAttribute('aria-labelledby', 'lenz-rmodal-title');
    dialog.innerHTML =
      '<div class="lenz-rmodal__head">' +
        '<h2 class="lenz-rmodal__title" id="lenz-rmodal-title">Escribe tu reseña</h2>' +
        '<button type="button" class="lenz-rmodal__close" aria-label="Cerrar">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="lenz-rmodal__body"></div>';
    dialog.querySelector('.lenz-rmodal__close').addEventListener('click', close);
    // Clic en el fondo (fuera de la caja) también cierra.
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('lenz-rmodal-lock');
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    });
    document.body.appendChild(dialog);
  }

  function open(trigger) {
    opener = trigger;
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    load().then(function () {
      if (!dialog) build();
      var body = dialog.querySelector('.lenz-rmodal__body');
      body.innerHTML = '';
      var root = document.createElement('div');
      root.className = 'lenz-rform';
      root.setAttribute('data-api', d.api || '');
      root.setAttribute('data-wa', d.wa || '');
      root.setAttribute('data-privacy', d.privacy || '');
      root.innerHTML = '<div data-rform-app></div>';
      body.appendChild(root);
      window.LenzReviewForm.mount(root, {
        embedded: true,
        product: { id: d.productId, title: d.title, image: d.image },
        onClose: close
      });
      document.documentElement.classList.add('lenz-rmodal-lock');
      dialog.showModal();
      body.scrollTop = 0;
      var first = dialog.querySelector('.lenz-rform__star input');
      if (first) first.focus({ preventScroll: true });
    }).catch(function () {
      // Sin red para el formulario: se va a la página de siempre.
      if (trigger && trigger.href) location.href = trigger.href;
    }).then(function () { if (trigger) trigger.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('[data-lenz-write], a[href*="/pages/resena?producto="]');
    if (!a) return;
    e.preventDefault();
    open(a);
  });

  // Enlace directo a la ficha con #escribir-resena abre la ventana.
  if (location.hash === '#escribir-resena') open(null);
})();
